import React from 'react'
import { FaPhoneAlt } from 'react-icons/fa';
import styled from 'styled-components'

const Avatar = styled.div`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    box-shadow: ${prop=>prop.theme.highBlueShadow};
`;

const NoMessageSelectedStyle = styled.div`
    display: grid;
    place-items: center;
    margin: auto 0;

    & > h3 {
        color:  ${prop=>prop.theme.grey};
        margin: 20px 0
    }
`;

function NoMessageSelected() {
    return (
        <NoMessageSelectedStyle>
            <Avatar>
                <FaPhoneAlt size={50} />
            </Avatar>
                <h3 className="title-bold"> No message selected </h3>
        </NoMessageSelectedStyle>
    )
}

export default NoMessageSelected
